import styled from "styled-components";

import { OnOffSwitch, OnOffSwitchSize, PlainTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { PeriodOverPeriodComprareTypesMenu } from "./PeriodOverPeriodComprareTypesMenu";
import { usePeriodOverPeriod } from "./usePeriodOverPeriod";

const Container = styled.div<{ $isDisabled: boolean }>`
    display: flex;
    align-items: center;
    height: 60px;
    padding: 0px;
    box-sizing: border-box;
    ${({ $isDisabled }) => `
        cursor: ${$isDisabled ? "not-allowed" : "pointer"};
    `}
`;

const ToggleContainer = styled(FlexRow)`
    height: 100%;
    padding: 0 4px 0 8px;
    align-items: center;
`;

export const PeriodOverPeriod = () => {
    const { isDisabled, onClick, isPoP, labelKey, onSelectCompareType, periodOverPeriodCompareTypes } =
        usePeriodOverPeriod();
    return (
        <PlainTooltip
            tooltipContent={translate("period.over.period.toggle.disabled.tooltip")}
            enabled={isDisabled}
        >
            <Container
                $isDisabled={isDisabled}
                data-automation="periodOverPeriod-container"
            >
                <ToggleContainer
                    onClick={isDisabled ? undefined : onClick}
                    data-automation="periodOverPeriod-toggle-container"
                >
                    <OnOffSwitch
                        isSelected={isPoP}
                        size={OnOffSwitchSize.small}
                        isDisabled={isDisabled}
                        className="period-over-period-toggle"
                    />
                </ToggleContainer>

                <PeriodOverPeriodComprareTypesMenu
                    onSelectCompareType={onSelectCompareType}
                    periodOverPeriodCompareTypes={periodOverPeriodCompareTypes}
                    isDisabled={isDisabled}
                    labelKey={labelKey}
                />
            </Container>
        </PlainTooltip>
    );
};
